export default "__VITE_ASSET__f3b1f7d8__"